var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPlanogramIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 14,
    viewBox: "0 0 36 14",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 0h9.8v14H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M0 0h9.8v14H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "M0 0h9.8v14H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(.48)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#C0C0D4",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EFEFF4",
    d: "M4.9 3.111l4.9 3.111v8.027L0 14.168V6.222z",
    mask: "url(#b)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.08)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#C0C0D4",
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EFEFF4",
    d: "M4.9 3.111l4.9 3.111v8.027L0 14.168V6.222z",
    mask: "url(#d)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.68)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#C0C0D4",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EFEFF4",
    d: "M4.9 3.111l4.9 3.111v8.027L0 14.168V6.222z",
    mask: "url(#f)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPlanogramIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/planogram-icon.ce9e2333e16f70705650a099bfbd22ab.svg";